import { useMemo } from 'react';
import useTeacherProfile from './useTeacherProfile';

const ADMINISTRATOR_PROFESSIONS: readonly string[] = [
  'school-administrator',
  'district-administrator',
  'technology-administrator',
  'administrator',
];

export interface UseIsAdminProfessionReturn {
  isAdminProfession: boolean;
  isLoading: boolean;
}

/*
 * Hook to determine if the current user has an administrator profession.
 * Returns both the computed value and the loading state.
 */
export default function useIsAdminProfession(): UseIsAdminProfessionReturn {
  const { data: teacherProfile, isLoading } = useTeacherProfile();

  const isAdminProfession = useMemo(
    () => ADMINISTRATOR_PROFESSIONS.includes(teacherProfile?.profession.name_localization_key ?? ''),
    [teacherProfile?.profession.name_localization_key],
  );

  return { isAdminProfession, isLoading };
}
